export enum AudienceDetailsStep {
	Basic,
	DistributionOptions,
}
